export default __webpack_public_path__ + "static/media/dashboard-image.544ff955.png";